import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { topOperadores } from 'app/interfaces/Meta';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-dialog-top-operadores',
  standalone: true,
  imports: [
    MatTableModule,
    MatDialogContent,
    MatDialogModule,
    MatDialogContent,
    CommonModule,
    TranslocoModule
  ],
  templateUrl: './dialog-top-operadores.component.html',
  styleUrl: './dialog-top-operadores.component.css'
})
export class DialogTopOperadoresComponent implements OnInit {
  public readonly dialog = Inject(MatDialog);
  public dataSouce: MatTableDataSource<topOperadores> = new MatTableDataSource();

  @Input() public topOperadoresLimitado!: topOperadores[];
  @Input() public modal: Boolean = true;

  public displayedColumns: string[] = ['posicao', 'vc_nome','produtividade', 'porcentagem', 'total'];
  public readonly coresOperadoresBarra = ['#CDE7FF', '#8CFAC7', '#C5A8FF', '#FFD5A4'];
  public readonly coresOperadoresReal = ['#0095FF', '#00E096', '#884DFF', '#FF8F0D'];

  constructor(
    public dialogRef: MatDialogRef<DialogTopOperadoresComponent>,
    @Inject(MAT_DIALOG_DATA) public data: topOperadores[]
  ) {
    this.dataSouce.data = data;
  }
  ngOnInit(): void {
    this.validaDataSouce();
  }

  public validaDataSouce():void{
    this.dataSouce.data = this.modal ? this.data : this.topOperadoresLimitado;
  }

  public fecharDialog(): void {
    this.dialogRef.close();
  }

  public retornaCorOperadores(tipo: 'barra' | 'real', index: number): string {
    const cores = tipo === 'barra' ? this.coresOperadoresBarra : this.coresOperadoresReal;
    return index > 3 ? cores[cores.length - 1] : cores[index % cores.length];
  }
}
